import type { AnyAction } from 'redux';

import { articleActionTypes } from '../data/article/article-slice';

import { COLOR_SHUFFLE_ACTIONS } from 'js/src/data/color-shuffle/color-shuffle-types';
import { TRANSCRIPT_TYPES } from 'js/src/data/transcript/transcript-types';
import { USER_OVERRIDES_ACTIONS } from 'js/src/data/user-overrides/user-overrides-types';
import { VIDEO_DATA_ACTIONS } from 'js/src/data/video-data/video-data-types';

// This contains all the undo-redo configs that are required to update the respective part of the application.
export const undoRedoConfig = {
    limit: 20,
    // In v1 of redux-undo, syncFilter is false by default.
    // This means that systemTriggered actions would not be added
    // to the history. When undoing a user triggered action(s), it
    // would be as if the systemTriggered actions never happened.
    // See https://github.com/omnidan/redux-undo/blob/master/docs/main/upgrading-to-1.0.md
    syncFilter: true,
    filter: function filterState(action: AnyAction) {
        const isVideoDataAction = Object.prototype.hasOwnProperty.call(
            VIDEO_DATA_ACTIONS,
            action.type,
        );
        const isUserOverridesAction = Object.prototype.hasOwnProperty.call(
            USER_OVERRIDES_ACTIONS,
            action.type,
        );
        const isArticleAction = articleActionTypes.includes(action.type);
        const isColorShuffleAction = Object.prototype.hasOwnProperty.call(
            COLOR_SHUFFLE_ACTIONS,
            action.type,
        );
        const isTranscriptAction = Object.prototype.hasOwnProperty.call(
            TRANSCRIPT_TYPES,
            action.type,
        );

        if (
            isVideoDataAction ||
            isUserOverridesAction ||
            isArticleAction ||
            isColorShuffleAction ||
            isTranscriptAction
        ) {
            // Filter actions that are only triggered by user interaction ( not by recommendation )
            return !(typeof action.payload === 'object' && action.payload.systemTriggered);
        } else {
            return false;
        }
    },
    groupBy: function (action: AnyAction) {
        return (typeof action.payload === 'object' && action.payload.parentActionGroup) ?? null;
    },
};
